import type { IncomingMessage } from 'http';

export interface AuthConfig {
  enabled?: boolean;
  token?: string;
}

export class AuthMiddleware {
  private enabled: boolean;
  private token: string | null;

  constructor(config?: AuthConfig) {
    this.enabled = config?.enabled ?? false;
    this.token = config?.token || null;

    // 如果启用了认证但没有提供 token，从环境变量读取
    if (this.enabled && !this.token) {
      this.token = process.env.PROXY_AUTH_TOKEN || null;
      if (!this.token) {
        throw new Error('Authentication is enabled but no token is provided');
      }
    }
  }

  authenticate(req: IncomingMessage): boolean {
    // 如果未启用认证，直接通过
    if (!this.enabled) {
      return true;
    }

    // 检查 Authorization 头
    const authHeader = req.headers.authorization;
    if (!authHeader) {
      return false;
    }

    // 支持 Bearer token
    const match = authHeader.match(/^Bearer (.+)$/i);
    if (!match) {
      return false;
    }

    const providedToken = match[1];
    return providedToken === this.token;
  }

  /**
   * 生成新的认证令牌
   */
  static generateToken(): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let token = 'pst_'; // proxy server token
    for (let i = 0; i < 32; i++) {
      token += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return token;
  }
}